import Create from './create/CreateParagraphSectionTemplate';
import Edit from './edit/EditParagraphSectionTemplate';
import Individual from './individual/ParagraphSectionTemplate';

export default { Create, Individual, Edit };
